<template>
  <div>
    <a-card title="半成品及成品管理">
      <a-row :gutter="16">
        <div style="margin-bottom: 12px; float: right">
          <a-button type="primary" icon="plus" style="margin: 0 8px" @click="openFormModal(form)">新增</a-button>
        </div>
      </a-row>

      <a-row style="margin-top: 12px; display: flex">
        <div class="leftPro" style="width: 21%" @scroll="onScroll">
          <ul>
            <li class="title">产品列表</li>
            <li>
              <a-input-search placeholder="id或名称" style="width: 230px; margin: 0 10px 20px" allowClear @search="onSearch" />
            </li>
            <li class="item" v-for="(val, index) in productList" @click="getBatchList(val.goods.id, index)" :key="index"
              :style="index === productIndex ? 'color: #40a9ff' : ''">
              <p style="margin: 0">{{ val.product_name }} ({{ val.product_id }})</p>
            </li>
          </ul>
        </div>

        <a-spin :spinning="loadingPici" style="margin: 0 20px">
          <ul class="leftPro">
            <li class="title">批次列表</li>
            <li>
              <a-input-search placeholder="请输入批次" style="width: 140px; margin: 0 10px 20px" allowClear @search="onSearch1" />
            </li>
            <li class="item" v-for="(val, index) in filteredBatchList"
              @click="getResultList(BatchList.product_id, index, val)" :key="index"
              :style="index === batchIndex ? 'color: #40a9ff' : ''">{{ val.batch }}</li>
          </ul>
        </a-spin>
        <a-table style="flex: 1" size="small" :pagination="pagination" :columns="columns" :dataSource="items"
          rowKey="id" :loading="loading" @change="tableChange">
          <div slot="is_active" slot-scope="value">
            <a-tag :color="value ? 'green' : 'red'">{{ value ? "激活" : "冻结" }}</a-tag>
          </div>
          <div slot="result" slot-scope="value">
            <span>{{ value && value.join(',') }}</span>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button icon="eye" size="small" @click="openFormModal2(item)">查看</a-button>
              <a-button icon="edit" size="small" @click="openFormModal1(item)">编辑</a-button>
              <a-popconfirm title="确定删除吗" @confirm="destroy(item.id)">
                <a-button type="danger" icon="delete" size="small">删除</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
    <form-modal :nowId="nowId" :BatchList="BatchList" v-model="visible" :form="targetItem"
      :clientsClassificationOptions="clientsClassificationItems" @create="create" @update="update" />
    <form-modal1 v-if="visible1" v-model="visible1" :BatchList="BatchList" :form="targetItem1" :reNumber="reNumber"
      :clientsClassificationOptions="clientsClassificationItems1" @create="create" @update="update" />
    <form-modal2 v-model="visible2" :form="targetItem2" :clientsClassificationOptions="clientsClassificationItems2"
      @create="create" @update="update" />
    <a-modal v-model="importLoading" :footer="null" :maskClosable="false" :closable="false">
      <div><a-spin style="margin-right: 12px" />正在导入中, 请等待...</div>
    </a-modal>
  </div>
</template>

<script>
import { fromProductList, traceabilityList, traceabilityDel, tracePici } from "@/api/from";
export default {
  name: "FromResult",
  components: {
    FormModal: () => import("./FormModal.vue"),
    FormModal1: () => import("./FormModal1.vue"),
    FormModal2: () => import("./FormModal2.vue")
  },
  computed: {
    filteredBatchList() {
      const pici = (this.BatchList && this.BatchList.pici) || [];
      if (!this.batchKeyword) return pici;
      return pici.filter(b => b.batch && b.batch.indexOf(this.batchKeyword) !== -1);
    }
  },
  data() {
    return {
      nowId: '',
      nowPici: '',
      reNumber: [],
      productList: [],
      productIndex: 0,
      batchIndex: 0,
      batchKeyword: '',
      BatchList: { pici: [] },
      columns: [
        {
          title: "检验标题",
          dataIndex: "title"
        },
        {
          title: "创建时间",
          dataIndex: "create_at"
        },
        {
          title: "批次",
          dataIndex: "date"
        },
        {
          title: "编号",
          dataIndex: "number"
        },
        {
          title: "描述",
          scopedSlots: { customRender: "result" },
          dataIndex: "result"
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          width: "156px",
        },
      ],
      pagination: { current: 1, total: 0, pageSize: 10 },
      searchForm: { product_id: "", pici: '', page: 1, page_size: 10 },
      loading: false,
      loadingPici: false,
      items: [],
      clientsClassificationItems: [],
      clientsClassificationItems1: [],
      clientsClassificationItems2: [],
      visible: false,
      visible1: false,
      visible2: false,
      targetItem: { data: {} },
      targetItem1: { data: {} },
      targetItem2: { data: {} },
      form: { data: {} },
      importLoading: false,
      page: 1,
      page_size: 100,
      productKw: '',
      productTotal: 0,
      loadingMoreProducts: false
    };
  },
  async created() {
    this.getRefresh()
  },
  methods: {
    async getRefresh() {
      this.page = 1;
      const params = { page: 1, page_size: this.page_size };
      if (this.productKw) params.product_kw = this.productKw;
      let res = await fromProductList(params);
      this.productList = (res.data || []).filter(item => item.goods);
      this.productTotal = res.count || 0;
      if (this.productList.length === 0) return;
      this.nowId = this.productList[0].goods.id
      this.getBatchList(this.productList[0].goods.id, 0)
    },
    async getProductList() {
      const params = { page: this.page, page_size: this.page_size };
      if (this.productKw) params.product_kw = this.productKw;
      let res = await fromProductList(params);
      this.productList = [...this.productList, ...(res.data || []).filter(item => item.goods)]
      this.productTotal = res.count || this.productTotal;
    },
    onScroll(e) {
      const bottomDistance = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
      if (bottomDistance < 50 && this.productList.length < this.productTotal && !this.loadingMoreProducts) {
        this.loadingMoreProducts = true;
        this.page++;
        this.getProductList().finally(() => { this.loadingMoreProducts = false; });
      }
    },
    openFormModal2(item) {
      item.result = item.result !== null ? item.result : []
      if (!item.id) {
        this.targetItem2 = JSON.parse(JSON.stringify(item));
      } else {
        let arr = item.image && item.image.map((img, index) => {
          if (typeof img === 'string') {
            const n = img.split('/')
            return {
              uid: index + '',
              name: n[n.length - 1],
              status: 'done',
              url: img,
            }
          } else {
            return img
          }
        });
        const normalized = { ...item, image: arr || [] };
        this.targetItem2 = JSON.parse(JSON.stringify(normalized));
      }
      this.visible2 = true;
    },
    getResultList(id, num, pici) {
      this.batchIndex = num;
      this.nowId = id;
      this.nowPici = pici.batch;
      this.list(id, pici.batch);

      // 更新form对象，确保使用当前批次的编号
      this.form = { data: {} };
      this.form.date = pici.batch;
      this.form.product_id = id;

      // 只有当该批次有编号时才设置编号
      if (pici.number && Array.isArray(pici.number) && pici.number.length > 0) {
        this.form.number = pici.number[0];
      } else {
        // 确保form对象中没有number属性
        this.form.number = null;
      }
    },
    getBatchList(val, num) {
      this.productIndex = num;
      this.batchListInfo(val);
    },
    async batchListInfo(id) {
      this.loadingPici = true;
      try {
        let res1 = await tracePici({ product_id: id });
        this.BatchList = res1.data || { pici: [] };
        this.nowId = id;

        // 检查是否有批次数据
        if (this.BatchList.pici && this.BatchList.pici.length > 0) {
          this.nowPici = this.BatchList.pici[0].batch;
          this.list(id, this.BatchList.pici[0].batch);
        } else {
          // 没有批次数据时的处理
          this.nowPici = '';
          this.list(id, '');
        }
      } finally {
        this.loadingPici = false;
      }
    },
    onSearch(val) {
      this.productIndex = null;
      this.productKw = val || '';
      this.getProductInfo(val)
    },
    async getProductInfo(val) {
      let res = await fromProductList({ product_kw: val || '', page: 1, page_size: this.page_size });
      this.productList = (res.data || []).filter(item => item.goods);
      this.productTotal = res.count || 0;
      this.page = 1;
      if (this.productList.length > 0) {
        this.productIndex = 0;
        const firstGoodsId = this.productList[0].goods.id;
        this.nowId = firstGoodsId;
        this.getBatchList(firstGoodsId, 0);
      } else {
        this.nowId = '';
        this.BatchList = { pici: [] };
        this.nowPici = '';
        this.items = [];
        this.pagination.total = 0;
      }
    },
    onSearch1(val) {
      this.batchKeyword = val || '';
      this.batchIndex = null;
    },
    list(id, pici) {
      this.searchForm.product_id = id;
      this.searchForm.pici = pici;
      this.loading = true;
      traceabilityList(this.searchForm)
        .then((data) => {
          this.pagination.total = data.count;
          this.items = (data.data || []).map(item => {
            // result 和 image 后端存的是 JSON 字符串，需要解析成数组
            if (typeof item.result === 'string') {
              try { item.result = JSON.parse(item.result) } catch(e) { item.result = [] }
            }
            if (!Array.isArray(item.result)) item.result = []
            if (typeof item.image === 'string') {
              try { item.image = JSON.parse(item.image) } catch(e) { item.image = [] }
            }
            if (!Array.isArray(item.image)) item.image = []
            return item
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async create(info) {
      const productId = (info && info.product_id) ? info.product_id : this.nowId;
      const date = (info && info.date) ? info.date : this.nowPici;
      // 刷新批次列表（不自动导航）
      this.loadingPici = true;
      let res1;
      try {
        res1 = await tracePici({ product_id: productId });
      } finally {
        this.loadingPici = false;
      }
      this.BatchList = res1.data || { pici: [] };
      this.nowId = productId;
      // 找到新建批次的 index
      if (this.BatchList.pici && date) {
        const idx = this.BatchList.pici.findIndex(b => b.batch === date);
        if (idx >= 0) this.batchIndex = idx;
      }
      this.nowPici = date;
      this.list(productId, date);
    },
    update() {
      this.list(this.nowId, this.nowPici);
    },
    openFormModal(item) {
      // 创建一个新的表单对象
      const newItem = {
        data: {},
        result: [],
        product_id: this.nowId,
        result3: ['半成品检测合格'],
        result4: ['成品检测合格'],
        result5: ['成品出库检测合格'],
        image3: [], image4: [], image5: [],
      };

      // 获取当前选中的批次
      if (this.BatchList && this.BatchList.pici && this.BatchList.pici.length > 0) {
        const selectedBatchIndex = this.batchIndex;
        const selectedBatch = this.BatchList.pici[selectedBatchIndex] || this.BatchList.pici[0];

        newItem.date = selectedBatch.batch;

        // 只有当该批次有编号时才设置编号
        if (selectedBatch.number && Array.isArray(selectedBatch.number) && selectedBatch.number.length > 0) {
          newItem.number = selectedBatch.number[0];
        } else {
          // 确保没有number属性
          newItem.number = null;
        }
      }

      this.targetItem = JSON.parse(JSON.stringify(newItem));
      this.visible = true;
    },
    openFormModal1(item) {
      item.result = item.result !== null ? item.result : []
      let arr = this.BatchList.pici.filter(obj => obj.batch == item.date).map(obj => obj.number).flat();
      this.reNumber = arr
      if (!item.id) {
        this.targetItem1 = JSON.parse(JSON.stringify(item));
      } else {
        let arr1 = item.image && item.image.map((img, index) => {
          if (typeof img === 'string') {
            const n = img.split('/')
            return {
              uid: index + '',
              name: n[n.length - 1],
              status: 'done',
              url: img,
            }
          } else {
            return img
          }
        });
        const normalized = { ...item, image: arr1 || [] };
        this.targetItem1 = JSON.parse(JSON.stringify(normalized));
      }
      this.visible1 = true;
    },
    destroy(id) {
      traceabilityDel({ id: id })
        .then(async (data) => {
          this.$message.success("删除成功");
          // 删除可能导致该批次消失（若 formulas 里也没有对应 batch）
          if (this.nowId) {
            this.loadingPici = true;
            try {
              const res1 = await tracePici({ product_id: this.nowId });
              const batchList = res1.data || { pici: [] };
              this.BatchList = batchList;
              const pici = batchList.pici || [];
              if (pici.length === 0) {
                this.nowPici = '';
                this.batchIndex = 0;
                this.items = [];
                this.pagination.total = 0;
                return;
              }
              const stillExists = this.nowPici && pici.some(b => b.batch === this.nowPici);
              if (!stillExists) {
                this.nowPici = pici[0].batch;
                this.batchIndex = 0;
              }
            } catch (e) {
              this.$message.warning('刷新批次列表失败，请手动切换产品重试');
              console.error('destroy 后刷新 tracePici 出错:', e);
            } finally {
              this.loadingPici = false;
            }
          }
          this.list(this.nowId, this.nowPici);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.searchForm.page_size = pagination.pageSize;
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      if (sorter && sorter.field && sorter.order) {
        this.searchForm.ordering = `${sorter.order === "descend" ? "-" : ""}${sorter.field}`;
      } else {
        delete this.searchForm.ordering;
      }
      this.list(this.nowId, this.nowPici);
    },
  },
  mounted() {
    // this.initialize();
  },
};
</script>

<style scoped lang="less">
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.leftPro {
  overflow-y: auto;
  overflow-x: hidden;
  height: 70vh;
  background: #eee;

  .title {
    font-weight: bold;
    text-align: center;
    line-height: 60px;
  }

  .item {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0 5% 20px 5%;
    cursor: pointer;
  }
}
</style>
